import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col } from "reactstrap";
import moment from "moment-timezone";
import axios from "axios";

import Form from "../../../general/Form/Form";

const initialState = {
  paymentAmount: "",
  startDate: "",
  endDate: "",
  campaignId: "",
  loadedPaymentSchedule: false
};

class PaymentScheduleModal extends Component {
  state = initialState;

  onFormSubmitHandler = (e) => {
    e.preventDefault();
    let startDate = moment(this.state.startDate).format("YYYY-MM-DD");
    let endDate = moment(this.state.endDate).format("YYYY-MM-DD");
    let campaignId = this.state.campaignId;
    let paymentAmount = this.state.paymentAmount;
    // clear fields
    this.setState(initialState);
    // send fields to campaign form
    this.props.edit
      ? this.props.update(startDate, endDate, campaignId, paymentAmount)
      : this.props.add(startDate, endDate, campaignId, paymentAmount);
  };

  deletePaymentSchedule = () => {
    // clear fields
    this.setState(initialState);
    // call delete to update ui
    this.props.delete();
  };

  paymentAmountChangeHandler = (e) => {
    this.setState({
      paymentAmount: e.target.value
    });
  };

  startDateChangeHandler = (e) => {
    this.setState({
      startDate: e.target.value
    });
  };

  endDateChangeHandler = (e) => {
    this.setState({
      endDate: e.target.value
    });
  };

  campaignSelectHandler = (e) => {
    this.setState({
      campaignId: parseInt(e.target.value)
    });
  };

  toggle = () => {
    this.setState(initialState);
    this.props.toggleModal();
  };

  componentDidUpdate = () => {
    if (this.props.edit && !this.state.loadedPaymentSchedule && Object.keys(this.props.data).length > 0) {
      this.setState({
        loadedPaymentSchedule: true,
        paymentAmount: this.props.data.monthly_rate,
        startDate: moment(this.props.data.start_date).utc().format("YYYY-MM-DD"),
        endDate: moment(this.props.data.end_date).utc().format("YYYY-MM-DD"),
        campaignId: this.props.data.campaign_id ? this.props.data.campaign_id : ""
      });
    }
  };

  componentDidMount = () => {
    window.setTimeout(async () => {
      try {
        let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign`, { withCredentials: true });
        if (res.status === 200 && res.data.active_campaigns) {
          let tempCampaigns = [...res.data.active_campaigns, ...res.data.in_production_campaigns];
          let campaigns = tempCampaigns
            .map((campaign) => {
              return { id: campaign.campaign_id, name: campaign.name };
            })
            .sort((a, b) => {
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            })
            .map((campaign) => (
              <option key={campaign.id} value={campaign.id}>
                {campaign.name}
              </option>
            ));
          this.setState({
            campaignList: campaigns
          });
        }
      } catch (err) {
        console.log(err);
      }
    }, 500);
  };

  render() {
    const formStyle = {
      boxShadow: "none"
    };
    let deleteButton = this.props.edit ? (
      <Button
        color="danger"
        onClick={this.deletePaymentSchedule}
        style={{ position: "absolute", left: "25px", bottom: "calc(8px + 0.25em)" }}
      >
        Delete
      </Button>
    ) : null;
    return (
      <Modal isOpen={this.props.show} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>{this.props.edit ? "Edit" : "Add"} Payment Schedule</ModalHeader>
        <ModalBody>
          <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
            <Row form className="mb-4">
              <Col md={6} className="pl-4 pr-4">
                <Label for="startDate">Payment Start Date</Label>
                <Row>
                  <Input type="date" value={this.state.startDate} onChange={this.startDateChangeHandler} />
                </Row>
              </Col>
              <Col md={6} className="pl-4 pr-4">
                <Label for="endDate">Payment End Date</Label>
                <Row>
                  <Input type="date" value={this.state.endDate} onChange={this.endDateChangeHandler} />
                </Row>
              </Col>
            </Row>
            <Row className="mb-2" form>
              <Col md={6}>
                <FormGroup>
                  <Label>Campaign</Label>
                  <Input type="select" onChange={this.campaignSelectHandler} value={this.state.campaignId}>
                    <option>-- Select a Campaign --</option>
                    {this.state.campaignList}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="paymentAmount">Payment Amount</Label>
                  <Input
                    type="number"
                    id="paymentAmount"
                    placeholder="Amount per month..."
                    value={this.state.paymentAmount}
                    onChange={this.paymentAmountChangeHandler}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          { deleteButton }
          <Button color="primary" onClick={this.onFormSubmitHandler}>
            {this.props.edit ? "Edit" : "Add"}
          </Button>
          <Button color="secondary" onClick={this.toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default PaymentScheduleModal;
